let UserId = null;

if (localStorage.getItem("UserId")) {
  UserId = localStorage.getItem("UserId");
}
const CSOROUTES = {
  GETCSOCLIENTBASICANDADVANCE: `clients/client/basic/advanced/all`,
};

export default CSOROUTES;
